// Stored price names are always written as "$6.50m" server-side; the game's chosen symbol is
// applied on display, so read the number back out and format it ourselves.
export const parseValue = (priceName) => Number(String(priceName).replace(/[^0-9.]/g, '')) || 0

export const formatValue = (value, symbol = '') =>
  value === null || value === undefined ? '—' : `${symbol}${Number(value).toFixed(2)}m`

// Values the server adds between the default edge and the chosen limit, in its 0.5 steps.
export const STEP = 0.5

export const extensionValues = (from, to) => {
  const values = []
  if (!from || !to) return values
  if (to < from) for (let v = from - STEP; v >= to; v -= STEP) values.push(v)
  else for (let v = from + STEP; v <= to; v += STEP) values.push(v)
  return values
}
